import { resolveEuAlarmTypeLabel } from './euEscudoUrbanoDisplay';

export type ButtonAlertMetadata = {
  latitud?: number;
  longitud?: number;
  site_name?: string | null;
  site_address?: string | null;
  source?: string | null;
  iot_type?: string | null;
  sound?: number | string | null;
  alarm_type_id?: number | string | null;
  stream_id?: string | null;
  stream_finalized?: boolean;
  reported_by?: string | null;
  datetimepush?: string | null;
  press_count?: number | string | null;
  alarm_group_key?: string | null;
};

export type PendingButtonAlertRow = {
  id: number;
  siteId: number | null;
  deviceId?: number;
  alertType?: string;
  message: string;
  metadata?: ButtonAlertMetadata;
  /** Enriquecido por la API cuando agrupa pulsaciones */
  pressCount?: number;
  comment?: string | null;
  createdAt?: string;
};

export function getMeta(a: PendingButtonAlertRow): ButtonAlertMetadata {
  const m = a.metadata;
  return m && typeof m === 'object' && !Array.isArray(m) ? (m as ButtonAlertMetadata) : {};
}

export function getSiteDisplayName(a: PendingButtonAlertRow): string {
  const meta = getMeta(a);
  const n = meta.site_name != null ? String(meta.site_name).trim() : '';
  if (n) return n;
  if (a.siteId != null) return `Sitio #${a.siteId}`;
  return 'Sin nombre de sitio';
}

export function getSiteAddressLine(a: PendingButtonAlertRow): string {
  const meta = getMeta(a);
  const addr = meta.site_address != null ? String(meta.site_address).trim() : '';
  return addr || '—';
}

export function getEuAlarmTypeLabel(a: PendingButtonAlertRow): string {
  const meta = getMeta(a);
  const aid = meta.alarm_type_id;
  const snd = meta.sound;
  return resolveEuAlarmTypeLabel({
    alarmTypeId: aid != null && aid !== '' ? Number(aid) : undefined,
    sound: snd != null && snd !== '' ? Number(snd) : undefined,
    message: a.message,
    alertType: a.alertType,
  });
}

/** Pulsaciones del botón en la misma ventana de agrupación (≥1). */
export function getAlarmPressCount(a: PendingButtonAlertRow): number {
  const top = a.pressCount;
  if (top != null && Number.isFinite(Number(top)) && Number(top) >= 1) {
    return Math.min(9999, Math.floor(Number(top)));
  }
  const meta = getMeta(a);
  const pc = Number(meta.press_count);
  if (Number.isFinite(pc) && pc >= 1) return Math.min(9999, Math.floor(pc));
  return 1;
}
